import React, { useState } from "react";
import { Modal, Box, Typography, Button, TextField, MenuItem, FormControl, RadioGroup, FormControlLabel, Radio, FormGroup, Checkbox } from "@mui/material";

const AFFilter = ({ Filter, toggle_Filter, SendDataToParent, applyFilter }) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedOption, setSelectedOption] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [selectedCheckboxValue, setSelectedCheckboxValue] = useState('');

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleCheckboxChange = (value) => {
    setSelectedCheckboxValue(selectedCheckboxValue === value ? '' : value); // Sirf ek checkbox check hoga
  };


  const SendDataToList = () => {
    SendDataToParent(fromDate, toDate, selectedOption, inputValue, selectedCheckboxValue)
  };
  

  return (
    <>
    
    <Modal
      open={Filter}
      onClose={toggle_Filter}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      BackdropProps={{
        sx: {
          backdropFilter: "blur(1px)",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      <Box sx={{ position: "absolute", top: "46%", left: "52%", transform: "translate(-50%, -50%)", width: 510, bgcolor: "background.paper", p: 4, borderRadius: '8px' }}>
        <Typography id="modal-title" variant="h6" component="h2" style={{ fontWeight: 'bold', color: '#303030' }}>
          Apply Filter
        </Typography>

        <Box display="flex" justifyContent="space-between" sx={{ mt: 2 }}>
          <TextField
            label="From Date"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: '48%' }}
          />
          <TextField
            label="To Date"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: '48%' }}
          />
        </Box>

        <Box display="flex" justifyContent="space-between" sx={{ mt: 2 }}>
          <TextField
            select
            label="Select"
            value={selectedOption}
            onChange={handleSelectChange}
            sx={{ width: '34%' }}
          >
            <MenuItem value="id">ID</MenuItem>
            <MenuItem value="vendor">Vendor</MenuItem>
            <MenuItem value="mobile">Mobile</MenuItem>
            <MenuItem value="request">Request</MenuItem>
            <MenuItem value="response">Response</MenuItem>
          </TextField>

          <TextField
            label="Input Field"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            sx={{ width: '65%' }}
          />
        </Box>

        {/* This Is Using That Time */}
        
        {/* <FormGroup row sx={{ mt: 2 }}>
       <FormControlLabel
            control={
              <Checkbox
                checked={selectedCheckboxValue === "Success"}
                onChange={() => handleCheckboxChange("Success")}
              />
            }
            label="Success"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedCheckboxValue === "Pending"}
                onChange={() => handleCheckboxChange("Pending")}
              />
            }
            label="Pending"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedCheckboxValue === "Failed"}
                onChange={() => handleCheckboxChange("Failed")}
              />
            }
            label="Failed"
          />
        </FormGroup> */}

        <Box display="flex" justifyContent="center" mt={3}>
          <Button variant="contained" color="primary" sx={{ mr: 5 }}
            onClick={() => {
              SendDataToList();  // Parent me data set karo
              toggle_Filter();    // Modal close karo
            }}>
            Apply
          </Button>

          <Button variant="contained" color="error" onClick={toggle_Filter}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
</>

  );
};

export default AFFilter;